import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { PublicApi } from '../constants';
import { AppResponse } from '../constants/ApiResponse';
import {
  Auth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
} from '@angular/fire/auth';

type PublicApiKeys = keyof typeof PublicApi;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private auth: Auth
  ) { }

  login1(username: string, password: string): boolean {
    if (username === 'admin' && password === '123') {
      const token = 'fake-jwt-token'; // Normally you would get this from the server
      localStorage.setItem('authToken', token);
      localStorage.setItem('userRole', 'admin'); // Store user role for authorization
      return true;
    } else return false;
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('authToken');
    const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
    if (!token || !userDetails || !userDetails?.verified || !userDetails?.isCompany || userDetails?.isCompany?.length === 0  ) {
      return false;
    }
    return true;
  }

  // Check if user is logged in
  isLoggedIn(): boolean {
    return !!localStorage.getItem('authToken');
  }

  logout1(): void {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    this.router.navigate(['auth/login']);
  }

  // Get user role for authorization
  getUserRole(): string | null {
    return localStorage.getItem('userRole');
  }

  getUserEmail(): string | null {
    const userDetails = localStorage.getItem('userDetails');
    if (userDetails) {
      const parsed = JSON.parse(userDetails);
      return parsed?.email || null;
    }
    return null;
  }
  getUserId(): string | null {
    const userDetails = localStorage.getItem('userDetails');
    if (userDetails) {
      const parsed = JSON.parse(userDetails);
      return parsed?.id || null;
    }
    return null;
  }

  getAll(endpoint: PublicApiKeys): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .get<AppResponse>(apiUrl)
      .pipe(catchError(this.handleError));
  }
  delete(endpoint: PublicApiKeys): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .delete<AppResponse>(apiUrl)
      .pipe(catchError(this.handleError));
  }
  deletebyId(
    endpoint: PublicApiKeys,
    id: string | number
  ): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .delete<AppResponse>(`${apiUrl}/${id}`)
      .pipe(catchError(this.handleError));
  }
  register(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }
  login(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }
  verify(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }
  logout(endpoint: PublicApiKeys, model: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = PublicApi[endpoint];
    return this.http
      .post<AppResponse>(apiUrl, model)
      .pipe(catchError(this.handleError));
  }

  getById(endpoint: PublicApiKeys, id: any): Observable<AppResponse> {
    // Use endpoint to access PublicApi dynamically
    const apiUrl = `${PublicApi[endpoint]}/${id}`;
    return this.http
      .get<AppResponse>(apiUrl)
      .pipe(catchError(this.handleError));
  }

 private handleError(error: any): Observable<never> {
  if (error.error instanceof ErrorEvent) {
    // Client-side error
    console.error(`Client-side error: ${error.error.message}`);
  } else {
    // Server-side error
    console.error(`Server-side error: ${error.status} - ${error.message}`);
  }
  
  // ✅ DON'T override the actual error - pass it through
  return throwError(() => error);
}
  setToken(data: any) {
    localStorage.setItem('authToken', data.user.authToken);
    localStorage.setItem('jwtToken', data.user.authToken);
    sessionStorage.setItem('jwtToken', data.user.authToken);
    // localStorage.setItem('userRole', data.user._roles.name);
    this.setUserDetails(data);
  }

  setTokenII(data: any) {
    localStorage.setItem('authToken', data.authToken);
    localStorage.setItem('jwtToken', data.authToken);
    sessionStorage.setItem('jwtToken', data.authToken);
    // localStorage.setItem('userRole', data.user._roles.name);
    this.setUserDetails(data.data);
  }


  setUserToken(data: any) {
    localStorage.setItem('userToken', data.user.authToken);
    localStorage.setItem('jwtToken', data.user.authToken);
    // localStorage.setItem('userRole', data.user._roles.name);
    sessionStorage.setItem('jwtToken', data.user.authToken);
  }

  setUserDetails(data: any) {
    localStorage.setItem('userDetails', JSON.stringify(data.user));
  }

  getUserDetails(): any {
    const userData = localStorage.getItem('userDetails');
    return userData ? JSON.parse(userData) : null;
  }

  signInWithGoogle() {
    return signInWithPopup(this.auth, new GoogleAuthProvider());
  }

  signInWithFacebook() {
    return signInWithPopup(this.auth, new FacebookAuthProvider());
  }
}
